export default {"src":"/_next/static/media/link_arrowV2.c7eb43da.svg","height":16,"width":19,"blurWidth":0,"blurHeight":0};